module.exports = __webpack_public_path__ + "static/media/map_pin_selected.8df4cef0.svg";